import React, {useEffect} from 'react';
import Header from "../components/Header";
import CustomeNavbar from "../components/CustomeNavbar";
import ProfileContent from "../contents/ProfileContent";
import ToTop from "../components/ToTop";
import Footer from "../components/Footer";
import SuratInternalContent from "../contents/SuratInternalContent";

const SuratInternal = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        scrollToTop();
    }, []);
    return (
        <div>
            <Header/>
            <CustomeNavbar/>
            <SuratInternalContent />
            <ToTop/>
            <Footer/>
        </div>
    );
};

export default SuratInternal;